import React from 'react';

function MonthAllocation({ data, monthName, year }) {  // Use monthName prop
  if (!data || data.length === 0) {
    return <div className="response">Details Not Found</div>;
  }
  const totalAayWheat = data.reduce((sum, item) => sum + parseFloat(item.aayWheat || 0), 0);
  const totalAayRice = data.reduce((sum, item) => sum + parseFloat(item.aayRice || 0), 0);
  const totalAaySugar = data.reduce((sum, item) => sum + parseFloat(item.aaySugar || 0), 0);
  const totalAayeWheat = data.reduce((sum, item) => sum + parseFloat(item.aayeWheat || 0), 0);
  const totalAayeRice = data.reduce((sum, item) => sum + parseFloat(item.aayeRice || 0), 0);
  const totalAayeSugar = data.reduce((sum, item) => sum + parseFloat(item.aayeSugar || 0), 0);
  const totalPhhWheat = data.reduce((sum, item) => sum + parseFloat(item.phhWheat || 0), 0);
  const totalPhhRice = data.reduce((sum, item) => sum + parseFloat(item.phhRice || 0), 0);
  const totalPhhSugar = data.reduce((sum, item) => sum + parseFloat(item.phhSugar || 0), 0);
  return (
    <div align="center">
      <table width="80%" border="1">
        <thead>
          <tr className="tableheader">
            <th colSpan="14">
              Scheme wise Allotment for <font style={{ color: "orange" }}>{monthName} - {year}</font>
            </th>
          </tr>
          <tr className="tableheader">
            <th rowSpan="3">Sl No </th>
            <th rowSpan="3">District</th>
            <th colSpan="9">NFSA</th>
          </tr>
          <tr className="tableheader">
           <th colSpan="3">AAY (Kgs)</th>
            <th colSpan="3">AAYE (Kgs)</th>
            <th colSpan="3">PHH (Kgs)</th>
          </tr>
          <tr className="tableheader">
            <th>Wheat</th>
            <th>Rice</th>
            <th>Sugar</th>
            <th>Wheat</th>
            <th>Rice</th>
            <th>Sugar</th>
            <th>Wheat</th>
            <th>Rice</th>
            <th>Sugar</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} style={item.distCode === 'B' ? {fontWeight: 'bolder', fontSize: '14px', color: '#0066cc'} : {}}>
              <td>{index + 1}</td>
              <td>{item.distName}</td>
              <td align="right">{item.aayWheat}</td>
              <td align="right">{item.aayRice}</td>
              <td align="right">{item.aaySugar}</td>
              <td align="right">{item.aayeWheat}</td>
              <td align="right">{item.aayeRice}</td>
              <td align="right">{item.aayeSugar}</td>
              <td align="right">{item.phhWheat}</td>
              <td align="right">{item.phhRice}</td>
              <td align="right">{item.phhSugar}</td>
            </tr>
          ))}
          <tr className="tableheader">
            <td>&nbsp;</td>
            <td>Total</td>
            <td align="right">{totalAayWheat.toFixed(3)}</td>
            <td align="right">{totalAayRice.toFixed(3)}</td>
            <td align="right">{totalAaySugar.toFixed(3)}</td>
            <td align="right">{totalAayeWheat.toFixed(3)}</td>
            <td align="right">{totalAayeRice.toFixed(3)}</td>
            <td align="right">{totalAayeSugar.toFixed(3)}</td>
            <td align="right">{totalPhhWheat.toFixed(3)}</td>
            <td align="right">{totalPhhRice.toFixed(3)}</td>
            <td align="right">{totalPhhSugar.toFixed(3)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MonthAllocation;
